import { useState } from "react";
import { Link, styled, Tooltip } from "@mui/material";
import { LatLngLiteral } from "leaflet";
import proj4 from "proj4";

import { PointInfoLink } from "types";
import { Error } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

interface Props {
  pointInfoLink: PointInfoLink;
  point: LatLngLiteral;
}

export function PointInfoLinkItem(props: Props) {
  const { pointInfoLink, point } = props;
  const { t } = useTranslation();
  const [error, setError] = useState<boolean>(false);

  function generateLink(pointInfoLink: PointInfoLink) {
    const { url, projection } = pointInfoLink;
    if (!url.includes("{x}" || "{y}") || !point) {
      return url;
    }

    const coordinates = convertCoordinates(point, projection);
    return mapUrlWithCoordinates(url, coordinates);
  }

  function mapUrlWithCoordinates(url: string, coordinates: LatLngLiteral) {
    const { lat, lng } = coordinates;
    return url.replace("{x}", lat.toString()).replace("{y}", lng.toString());
  }

  function convertCoordinates(
    point: LatLngLiteral,
    projection?: string
  ): LatLngLiteral {
    if (!projection) return point;
    try {
      const [lat, lng] = proj4(projection, [point.lat, point.lng]);
      return { lat: lat, lng: lng };
    } catch (e) {
      if (!error) setError(true);
      return point;
    }
  }

  return (
    <Styles>
      <Link
        key={pointInfoLink.id}
        href={generateLink(pointInfoLink)}
        className={`${error ? "error" : ""}`}
      >
        {pointInfoLink.label}
      </Link>
      {error && (
        <Tooltip title={t<string>("label.incorrectProjection")}>
          <Error color="error" />
        </Tooltip>
      )}
    </Styles>
  );
}

const Styles = styled("div")`
  display: flex;
  justify-content: space-between;
  align-items: center;
  .error {
    color: ${({ theme }) => theme.palette.error.main};
  }
`;
